import ArticleList from "./article-list.vue";

window.Vue.createApp({
    components: {
        ArticleList,
    },
}).mount("#news-component");
